// @flow
import bowser from 'bowser';

const injectUTMIntoContext = (options: any = {}) => {
  const newOptions = options || {};
  if (window.utm_parameters) {
    newOptions.context = newOptions.context || {};
    newOptions.context.campaign = window.utm_parameters;
  }
  return newOptions;
};

export const track = (
  eventName: string,
  properties: any = {},
  options: any = {}
) => {
  if (window.analytics && window.analytics.track) {
    const Platform = `Ava ${window.isElectron ? 'Desktop' : 'Web'}`;
    const browser = bowser.getParser(window.navigator.userAgent);
    const OS =
      browser.parsedResult &&
      browser.parsedResult.os &&
      browser.parsedResult.os.name;
    window.analytics.track(
      eventName,
      { ...properties, Platform, OS },
      injectUTMIntoContext(options)
    );
  }
};
export const identifyWithId = (
  userId: string,
  traits: any = {},
  options: any = {}
) => {
  if (window.analytics && window.analytics.identify) {
    injectUTMIntoContext(options);
    window.analytics.identify(userId, traits, injectUTMIntoContext(options));
  }
};

export const identify = (traits: any = {}, options: any = {}) => {
  if (window.analytics && window.analytics.identify) {
    injectUTMIntoContext(options);
    window.analytics.identify(traits, injectUTMIntoContext(options));
  }
};

export const reset = () => {
  if (window.analytics && window.analytics.reset) {
    window.analytics.reset();
  }
};
